import { FC } from 'react';

type Props = {
    hits: number;
};

const HitsCell: FC<Props> = ({ hits }) => {
    return (
        <div className="w-fit text-12 bg-sf-white border border-sf-gray-100 rounded-[4px] px-2">
            {hits.toLocaleString()}
        </div>
    );
};

export default HitsCell;
